// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BGIPb","question":"styles_question__2sTrT","description":"styles_description__2u1BR"};